export default __webpack_public_path__ + "static/media/F1_9.a97da480.png";